<template>
  <div class="l-contentmain contentmain">
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <router-link :to="{ name: 'UserList'}">
            Fiche de présentation
          </router-link>
        </h1>
        <div class="page-header-breadcrumb-separator" />
        <div class="page-header-breadcrumb-item">
          <span class="has-text-weight-normal has-text-grey-dark">Édition</span>
        </div>
      </template>
    </page-nav-bar>
    <spinner-round
      v-if="loading"
      :is-loading="loading" />
    <page-content
      v-else-if="!loading"
      :has-left-col-xsmall="true"
      :has-sticky-col-left="true"
      :has-padd-right-normal="true"
      :set-main-col-class="''">
      <!-- LEFT CONTENT -->
      <template slot="left-col-small">
        <aside class="menu menu--admin">
          <ul class="menu-list has-background-white is-border">
            <li class="is-active">
              <a>Informations promoteur</a>
              <ul>
                <li
                  id="tabs-COORDONEES"
                  :class="{'is-active' : panel === 'COORDONEES'}">
                  <a @click="panel = 'COORDONEES'">
                    <div class="is-uppercase">coordonnées</div>
                  </a>
                </li>
                <li
                  id="tabs-DESCRIPTION"
                  :class="{'is-active' : panel === 'DESCRIPTION'}">
                  <a @click="panel = 'DESCRIPTION'">
                    <div class="is-uppercase">description</div>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </aside>
      </template>
      <!-- RIGHT CONTENT -->
      <div>
        <form
          @submit.prevent.stop="">
          <div
            v-show="panel === 'COORDONEES'"
            class="has-background-white is-border">
            <div class="columns is-gapless has-background-warning is-marginless">
              <div class="is-size-7 is-padding">
                <span class="icon is-small is-margin-right-xxsmall has-text-success">
                  <i class="fas fa-check-circle" />
                </span>
                <span class="is-uppercase has-text-weight-bold">information nécéssaire à la validation de la fiche de présentation</span>
              </div>
            </div>
            <!-- PROMOTER DATA -->
            <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="is-size-5 is-uppercase">
                <span v-helper.right="'51vTE0PPtD1lrL4OP0a3rh'">données promoteur&nbsp;&nbsp;<i class="fal fa-info-circle" /></span>
              </div>
            </div>
            <div class="has-background-white--darken1 is-padding">
              <div class="columns is-multiline">
                <div class="column is-6">
                  <!-- NAME -->
                  <r-label
                    :is-required="true"
                    :red-check="true"
                    :value="promoteur.name"
                    label="Nom de la société de promotion" />
                  <div class="control">
                    <v-input
                      id="name"
                      v-validate="'required'"
                      name="name"
                      :model="promoteur.name"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      classes="input"
                      data-vv-as="Nom de la société"
                      @input="promoteur.name = $event" />
                  </div>
                </div>
                <!-- ADDRESS -->
                <div class="column is-12">
                  <address-input
                    :source="promoteur.address"
                    :is-required="false"
                    :red-check="true"
                    @update="promoteur.address = $event" />
                </div>
                <!-- PHONE -->
                <div class="column is-6">
                  <r-label
                    :is-required="false"
                    label="Téléphone de contact" />
                  <div class="control">
                    <v-input
                      id="phone"
                      name="phone"
                      @input="promoteur.phone = $event"
                      :model="promoteur.phone"
                      :errors-bag="errors"
                      :input-type="'tel'"
                      :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                      v-validate="'min:10'"
                      data-vv-value-path="val"
                      data-vv-as="Téléphone de contact"
                      :has-addons="true">
                      <p
                        class="control"
                        slot="addonLeft">
                        <a class="button is-square is-static is-border">
                          <span class="icon"><i class="fas fa-phone-office"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
                <!-- WEBSITE -->
                <div class="column is-6">
                  <r-label
                    :red-check="false"
                    :is-required="false"
                    label="Site internet" />
                  <div class="control">
                    <v-input
                      id="web_site"
                      v-validate="'url'"
                      name="web_site"
                      type="text"
                      :model="promoteur.web_site"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      classes="input"
                      data-vv-as="Site internet"
                      @input="promoteur.web_site = $event" />
                  </div>
                </div>
                <!-- LOGO-->
                <div class="column is-12">
                  <r-label
                    :label="'Logo de la société'"
                    :for-id="''"
                    :is-required="false" />
                  <upload-file
                    :custom-id="'logo'"
                    :source-documents="promoteur.picture"
                    :unique="true"
                    :is-square-input="false"
                    @upload="uploadFile({ file: $event, target: 'picture' })"
                    @deleteDocument="(...args) => deleteFile(...args, 'picture')" />
                </div>
              </div>
            </div>
            <!-- SOCIAL NETWORKS -->
            <div class="has-background-light is-padding">
              <div class="columns is-multiline is-12 is-padding-top is-paddingless">
                <div class="column title is-5 is-uppercase is-margin-bottom-xsmall">
                  <b>Réseaux sociaux</b>
                </div>
                <div class="column is-7" />
                <div
                  v-for="(media, i) in promoteur.social_media"
                  :key="i"
                  class="column is-7">
                  <template v-if="i < 5">
                    <div class="field">
                      <div class="is-flex is-margin-bottom-xxsmall">
                        <div class="is-self-centered">
                          <r-label
                            class="is-inline-flex"
                            :is-required="false" />
                        </div>
                      </div>
                      <div class="control">
                        <v-input
                          :id="'mediaUrl' + i"
                          v-validate="'url'"
                          :has-addons="true"
                          :name="'mediaUrl' + i"
                          :model="media.url"
                          data-vv-as="URL"
                          :errors-bag="errors"
                          data-vv-value-path="val"
                          @input="media.url = $event">
                          <p
                            slot="addonLeft"
                            class="control">
                            <button class="button is-static">
                              <span>{{ media.label }}</span>
                            </button>
                          </p>
                          <p
                            slot="addonRight"
                            class="control">
                            <a
                              class="button is-square is-grey is-inverted is-border"
                              @click.prevent.stop="media.url = ''">
                              <i class="fal fa-trash-alt" />
                            </a>
                          </p>
                        </v-input>
                      </div>
                    </div>
                    <!-- </div> -->
                  </template>
                </div>
                <div class="column is-5" />
              </div>
            </div>
            <!-- REFERENTS PRESCRIBERS -->
            <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-border-bottom">
              <div class="is-size-5 is-uppercase">
                <span v-helper.right="'2OFlSEEjutEZvB8mSqvvt0'">référents prescripteurs&nbsp;&nbsp;<i class="fal fa-info-circle" /></span>
              </div>
            </div>
            <div class="is-padding-right is-padding-left is-padding-bottom-xlarge">
              <div
                v-for="(referent, i) in promoteur.referents"
                :key="'referent'+i"
                class="columns is-multiline is-padding-top">
                <div class="column is-11 is-uppercase">
                  référent à contacter {{ i + 1 }}
                </div>
                <div class="column is-1">
                  <a
                    class="button is-square is-grey is-inverted is-border is-pulled-right"
                    @click.prevent.stop="promoteur.referents.splice(i, 1)">
                    <i class="fal fa-trash-alt" />
                  </a>
                </div>
                <div class="column is-3">
                  <!-- LASTNAME -->
                  <r-label
                    :is-required="false"
                    label="Nom" />
                  <div class="control">
                    <v-input
                      v-validate="''"
                      :model="referent.last_name"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      classes="input"
                      data-vv-as="Nom"
                      @input="referent.last_name= $event" />
                  </div>
                </div>
                <div class="column is-3">
                  <!-- FIRSTNAME -->
                  <r-label
                    :is-required="false"
                    label="Prénom" />
                  <div class="control">
                    <v-input
                      v-validate="''"
                      :model="referent.first_name"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      classes="input"
                      data-vv-as="Prénom"
                      @input="referent.first_name = $event" />
                  </div>
                </div>
                <div class="column is-4">
                  <!-- PROFESSION -->
                  <r-label
                    :is-required="false"
                    label="profession" />
                  <div class="control">
                    <v-input
                      v-validate="''"
                      :model="referent.profession"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      classes="input"
                      data-vv-as="profession"
                      @input="referent.profession = $event" />
                  </div>
                </div>
                <div class="column is-3">
                  <!-- EMAIL -->
                  <r-label
                    :is-required="false"
                    label="Mail" />
                  <div class="control">
                    <v-input
                      :id="'referent.email'+i"
                      v-validate="'email'"
                      :name="'referent.email'+i"
                      :model="referent.email"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      classes="input"
                      data-vv-as="Email"
                      @input="referent.email = $event" />
                  </div>
                </div>
                <div class="column is-3">
                  <!-- PHONE -->
                  <r-label
                    :is-required="false"
                    label="Téléphone" />
                  <div class="control">
                    <v-input
                      :name="'referent.phone'+i"
                      :id="'referent.phone'+i"
                      @input="referent.phone = $event"
                      :model="referent.phone"
                      :errors-bag="errors"
                      :input-type="'tel'"
                      :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                      v-validate="'min:10'"
                      data-vv-value-path="val"
                      data-vv-as="Téléphone"
                      :has-addons="true">
                      <p
                        class="control"
                        slot="addonLeft">
                        <a class="button is-square is-static is-border">
                          <span class="icon"><i class="fas fa-phone-office"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
                <!-- PICTURE -->
                <div class="column is-12 field">
                  <r-label
                    :label="'Photo'"
                    :is-required="false" />
                  <upload-file
                    :custom-id="'referentPicture'+i"
                    :source-documents="referent.picture"
                    :unique="true"
                    :is-square-input="false"
                    @upload="uploadFile({ file: $event, target: 'referents', referentIndex: i })"
                    @deleteDocument="(file, index) => deleteFile(file, i, 'referents')" />
                </div>
              </div>
              <div
                v-if="promoteur.referents.length < 5"
                class="is-padding-top has-text-right">
                <a
                  class="button is-rounded is-transform-none is-padding-right-large is-padding-left-large"
                  @click="promoteur.referents.push({ last_name: null, first_name: null, email: null, phone: null, profession: null, picture: [] })">
                  &nbsp;<span class="icon is-small has-text-grey"><i class="fas fa-plus-square" /></span><span>Ajouter un référent</span></a>
              </div>
            </div>
          </div>
          <div
            v-show="panel === 'DESCRIPTION'"
            class="has-background-white is-border">
            <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="is-size-5 is-uppercase">
                <span>documents&nbsp;&nbsp;</span>
              </div>
            </div>
            <div class="is-padding">
              <div class="columns is-multiline">
                <!-- BROCHURE -->
                <div class="column is-12 field is-padding-bottom-xsmall">
                  <r-label
                    :label="'Plaquette de présentation'"
                    :for-id="''"
                    :is-required="false" />
                  <upload-file
                    :custom-id="'brochure'"
                    :source-documents="promoteur.document"
                    :unique="true"
                    :is-square-input="false"
                    @upload="uploadFile({file: $event, target: 'document'})"
                    @deleteDocument="(...args) => deleteFile(...args, 'document')" />
                </div>
                <!-- PICTURES -->
                <div class="column is-12 field is-padding-top-xsmall is-padding-bottom-xsmall">
                  <r-label
                    :truncate="false"
                    label="Photos et illustrations"
                    :is-required="false">
                    <span
                      v-helper.right="'1pNPb4UJYiRlyqCKOhCqdK'"
                      class="is-padding-left-xsmall"><i class="fal fa-info-circle" /></span>
                  </r-label>
                  <upload-file
                    :custom-id="'pictures'"
                    :multiple="true"
                    :drag-enabled="true"
                    :source-documents="promoteur.pictures"
                    @upload="uploadFile({file: $event, target: 'pictures'})"
                    @deleteDocument="(...args) => deleteFile(...args, 'pictures')" />
                </div>
              </div>
            </div>
            <!-- DESCRIPTIONS -->
            <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="is-size-5 is-uppercase">
                <span v-helper.right="'1aeK5deOmK7eCAj2bPUquH'">descriptions&nbsp;&nbsp;<i class="fal fa-info-circle" /></span>
              </div>
            </div>
            <div class="has-background-white--darken1 is-padding">
              <div
                v-for="(description, i) in promoteur.descriptions"
                :key="'description'+i"
                class="columns is-multiline is-padding-bottom">
                <!-- TITLE -->
                <div class="column">
                  <div class="columns is-vcentered">
                    <div class="column">
                      <r-label
                        :is-required="false"
                        :label="'Titre de la description ' + (i + 1)" />
                    </div>
                    <div class="column is-narrow has-text-right">
                      <a
                        class="button is-square is-border is-radiusless "
                        @click.prevent.stop="promoteur.descriptions.splice(i, 1)">
                        <i class="fal fa-trash-alt" />
                      </a>
                    </div>
                  </div>
                </div>
                <div class="column is-12">
                  <div class="control">
                    <v-input
                      v-validate="''"
                      :model="description.title"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      classes="input"
                      data-vv-as="Titre de la description"
                      @input="description.title = $event" />
                  </div>
                </div>
                <!-- TEXT -->
                <div class="column">
                  <r-label
                    :is-required="false"
                    :label="'Texte de la description ' + (i + 1)" />
                  <wysiwyg-editor
                    :light="true"
                    :tooltip-top="true"
                    :model="description.text"
                    class="has-background-white"
                    @change="val => description.text = val" />
                </div>
              </div>
              <div
                v-if="promoteur.descriptions.length < 5"
                class="is-padding-right is-padding-left is-padding-bottom has-text-right">
                <a
                  class="button is-rounded is-transform-none is-padding-right-large is-padding-left-large"
                  @click="promoteur.descriptions.push({ title: null, text: null })">
                  &nbsp;<span class="icon is-small has-text-grey"><i class="fas fa-plus-square" /></span><span>Ajouter une description</span></a>
              </div>
            </div>
          </div>
          <submit-sticky-buttons
            :loading="submitLoading"
            button-id="programForm"
            @submit="submitForm" />
        </form>
      </div>
    </page-content>
  </div>
</template>

<script>
/** Promoteur presentation edition form */
import { cloneDeep } from 'lodash'
export default {
  name: 'PromoteurPresentationEdit',
  data () {
    return {
      loading: false,
      submitLoading: false,
      promoteur: null,
      panel: 'COORDONEES',
      socialMediaList: [ // a mettre dans defaultvalues /// tester avec un bouton de validation
        { url: '', label: 'Linkedin' },
        { url: '', label: 'Facebook' },
        { url: '', label: 'Instagram' },
        { url: '', label: 'Twitter' },
        { url: '', label: 'Youtube' }
      ]
    }
  },
  computed: {
    isAdminReferent () {
      return this.user.first_admin
    },
    /** Format address to one line string. */
    address () {
      if (this.promoteur.address.line1 && this.promoteur.address.zip_code && this.promoteur.address.city) {
        return `${this.promoteur.address.line1} ${this.promoteur.address.zip_code} ${this.promoteur.address.city} ${this.promoteur.address.country || ''}`
      }
      return null
    },
    accountPk () {
      return this.$route.params.id
    }
  },
  watch: {},
  async created () {
    this.loading = true
    await this.fetchFichePromoteur()
    this.loading = false
  },
  methods: {
    /** Fetch promoteur data and initialize default values */
    async fetchFichePromoteur () {
      try {
        const { data } = await this.$api.get(`/accounts/${this.accountPk}/promoteur-details`)
        if (!data.social_media.length) {
          data.social_media = this.socialMediaList
        }
        if (!data.descriptions.length === 0) {
          data.descriptions.push({ title: '', text: '' })
        }
        data.picture = data.picture ? [data.picture] : []
        data.document = data.document ? [data.document] : []
        data.referents = data.referents.map(ref => {
          ref.picture = ref.picture ? [ref.picture] : []
          return ref
        })

        this.promoteur = data
      } catch (e) {
        console.log(e)
      }
    },
    /** Assign uploaded and cropped files to promoter model.
     *  @param {Object[]} file cloudinary file array
     *  @param {string} target target property on promoter's object
     *  @param {string} referentIndex referent index to update
     */
    uploadFile ({ file, target, referentIndex = null }) {
      const isCropped = file.cropped
      const croppedIndex = file.croppedIndex
      file = file[0]

      if (target === 'picture') {
        this.promoteur[target] = [{ ...file }]
      } else if (target === 'document') {
        this.promoteur[target] = [{ ...file }]
      } else if (target === 'referents') {
        this.promoteur.referents[referentIndex].picture = [{ ...file }]
      } else if (target === 'pictures') {
        if (isCropped) {
          this.promoteur.pictures[croppedIndex] = { ...file }
          return
        }
        this.promoteur.pictures.push({ ...file })
      }
    },
    /** Delete files from promoter model.
     *  @see uploadFile for further information.
    */
    deleteFile (file, index = null, target) {
      if (target === 'referents') {
        this.promoteur[target][index].picture = []
      } else {
        this.promoteur[target].splice(index, 1)
      }
    },
    /** check if obj is empty */
    checkEmpty (obj) { for (var key in obj) { if (obj[key] !== null && obj[key] !== '') return false } return true },
    /** Submit form and format fields */
    async submitForm () {
      const formIsValid = await this.$validator.validateAll()
      if (!formIsValid) {
        this.$toasted.global.danger('Formulaire invalide !')
        return
      }
      this.submitLoading = true
      const payload = cloneDeep(this.promoteur)

      // reset fields if no value (backend validation rule)
      if (payload.phone === '') payload.phone = null
      if (!payload.address) payload.address = {}
      if (payload.descriptions.length === 1 && payload.descriptions[0].title === '' && payload.descriptions[0].text === '') {
        payload.descriptions = []
      }

      // reset fields if no picture or extract picture object (single pictures should not be stored as array in db)
      payload.picture = payload.picture.length ? payload.picture[0] : null
      payload.document = payload.document.length ? payload.document[0] : null
      payload.referents = payload.referents.map(ref => {
        ref.picture = ref.picture.length ? ref.picture[0] : null
        return ref
      })
      if (payload.referents.length) {
        payload.referents = payload.referents.filter(x => !this.checkEmpty(x))
      }

      // append protocol to social links
      payload.social_media = payload.social_media.map(media => {
        if (media.url.length && !media.url.toLowerCase().startsWith('http')) {
          media.url = 'https://' + media.url
        }
        return media
      })

      try {
        await this.$api.axios.put(`/accounts/${this.accountPk}/promoteur-details`, payload)
        this.$toasted.global.success('Fiche modifiée !')
        this.$router.push({ name: 'PromoteurPresentation', params: { id: this.accountPk } })
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
      this.submitLoading = false
    }
  }
}

</script>
